/**
 * 캔버스 버퍼 크기를 물리 픽셀 기준으로 동기화한다.
 * 크기가 이미 맞으면 아무것도 하지 않는다 (canvas 크기 변경은 clear 를 유발).
 */
export const syncCanvasSize = (
  canvas: HTMLCanvasElement,
  cssHeight: number,
  cssWidth: number,
  pixelRatio: number,
): { bufH: number; bufW: number } => {
  const bufW = Math.round(cssWidth * pixelRatio);
  const bufH = Math.round(cssHeight * pixelRatio);

  if (canvas.width !== bufW || canvas.height !== bufH) {
    canvas.width = bufW;
    canvas.height = bufH;
  }

  return { bufH, bufW };
};
